{
	"it": {
		"food": "Cibi",
		"special": "Speciali",
		"grains": "Cereali",
		"nuts": "Fr. guscio",
		"dietary": "Dieta & Altro",
		"description": "Descrizione",
		"long_description": "Descrizione lunga",
		"materials": "Materiali",
		"ingredients": "Ingredienti",
		"reviews": "Recensioni",
		"reviews_x": "[0] recensioni",
		"quality": "Qualità",
		"service": "Servizio",
		"price": "Prezzo",
		"location": "Posizione",
		"reservations": "Prenotazioni",
		"menu": "Menu",
		"add": "Aggiungi",
		"add_x": "Aggiungi x[0]",
		"no_choice_available": "Nessuna scelta disponibile",
		"amount_to_pay": "Importo da pagare",
		"how_do_you_want_to_pay": "Come vuoi pagare?",
		"pay_everything": "Paga tutto",
		"pay_custom_amount": "Paga un importo parziale",
		"split_evenly": "Dividi alla romana",
		"pay_what_you_ordered": "Paga la tua parte",
		"select_what_you_ordered": "Seleziona i tuoi prodotti",
		"clear": "Rimuovi",
		"pay_the_bill": "Paga il conto",
		"mandatory": "Obbligatorio",
		"min_x": "Min. [0]",
		"max_x": "Max. [0]",
		"data_processing": "Trattamento dei dati",
		"privacy_read_link": "Letta l'[0]",
		"privacy_policy_link": "informativa sulla privacy",
		"allow_marketing": "presto il mio consenso per l'analisi delle mie scelte di acquisto e per l'invio di comunicazioni promozionali a mezzo email",
		"change_language": "Cambia lingua",
		"allergens_filter_line_1": "Rimuovi gli allergeni per visualizzare solo i prodotti adatti a te.",
		"allergens_filter_line_2": "Tutti i prodotti possono contenere tracce dei seguenti allergeni.",
		"allergens_in_cart": "Prodotti con allergeni nel carrello",
		"allergens_in_cart_confirm": "Ci sono prodotti nel carrello che contengono allergeni che hai scelto di non visualizzare. Vuoi tenerli comunque nel carrello?",
		"product_filtered": "Prodotto filtrato",
		"product_filtered_confirm": "Questo prodotto contiene allergeni che hai filtrato. Vuoi aggiungerlo comunque al carrello?",
		"category_filtered": "Categoria filtrata",
		"category_filtered_confirm": "Tutti i prodotti in questa categoria hanno allergeni che hai filtrato. Vuoi rimuovere i filtri?",
		"category_filtered_search_confirm": "Tutti i prodotti di questa categoria non corrispondono alla ricerca, vuoi rimuovere la ricerca?",
		"max_choice_list": "Non puoi aggiungere più di [0] prodotti alla lista [1]",
		"max_choice_list_single": "Non puoi aggiungere più di un prodotto alla lista [0]",
		"too_big_to_translate": "Il menù è troppo grande per essere tradotto",
		"too_big_to_translate_catalog": "Il catalogo è troppo grande per essere tradotto",
		"conditions_not_matched_list": "Condizioni non soddisfatte per la lista [0]",
		"conditions_not_matched_multiple_lists": "Condizioni non soddisfatte per [0] liste",
		"not_available": "Non disponibile",
		"item_not_available_quantity": "In questo momento non puoi ordinare più di [0] [1]",
		"category_not_available_quantity": "In questo momento non puoi ordinare più di [0] nella categoria [1]",
		"item_not_available": "Non puoi ordinare il prodotto [0]",
		"more_info_allergens_link": "Per maggiori informazioni sugli allergeni",
		"table_number": "Numero tavolo",
		"phone_number": "Numero di telefono",
		"phone_number_explain": "Riceverai un messaggio quando il tuo ordine è pronto.",
		"phone_country_code": "Prefisso internazionale",
		"missing_phone_number": "Inserisci il numero di telefono per essere avvisato quando l'ordine è pronto.",
		"missing_table_number": "Inserisci il numero del tavolo",
		"missing_customer_name": "Inserisci il tuo nome",
		"missing_customer_email": "Inserisci la tua email",
		"invalid_phone": "Numero di telefono non valido",
		"invalid_email": "Email non valida",
		"invalid_captcha": "Capcha non valido",
		"send_to_terminal": "Manda al Kiosk",
		"or_pay_online": "Oppure paga online",
		"pay_in_3_installments": "Paga in 3 rate",
		"generic_page_description": "Scopri il [0] di [1] e tutti i suoi prodotti.",
		"pay_with": "Paga con",
		"satispay": "Satispay",
		"klarna": "Klarna",
		"cover_charge": "Coperto",
		"expires": "Scadenza [0]/[1]",
		"order_time": "Orario ordine",
		"ASAP": "Prima possibile",
		"schedule": "Programma",
		"missing_address": "Inserisci l'indirizzo di consegna completo",
		"address_details": "Info consegna (citofono, piano)",
		"popular": "Popolare",
		"recommended": "Consigliato",
		"popular_choices": "Scelte popolari",
		"we_recommend": "Ti consigliamo",
		"continue": "Continua",
		"pay_now": "Paga ora",
		"pay_later": "Paga dopo",
		"cannot_be_zero": "L'importo deve essere maggiore di zero",
		"cash": "Contanti",
		"no_date": "Nessuna data",
		"other_methods": "Altri",
		"other_methods_full": "Altri metodi",
		"your_name": "Il tuo nome",
		"write_your_name": "Scrivi il tuo nome",
		"click_here": "clicca qui",
		"allergens_info": "Info allergeni",
		"order_here": "Ordina qui",
		"order_here_now": "Ordina direttamente da qui",
		"explain_coupon_button": "Clicca '+' per applicare il codice sconto",
		"notes": "Note",
		"order_failed": "Si è verificato un problema. Ricarica la pagina e riprova.",
		"order_failed_later": "Si è verificato un problema. Riprova più tardi.",
		"pay_card_declined": "Pagamento rifiutato. Prova un'altra carta.",
		"pay_network_error": "Errore di connessione. Riprova tra qualche istante.",
		"pay_requires_pin": "Questa carta richiede il PIN. Usa un'altra carta o chiedi al personale.",
		"fee_greater_than_total": "La commissione è maggiore del totale, riprova per favore.",
		"choose_time": "Scegli l'orario",
		"no_slots": "Nessun orario disponibile per questa data",
		"couriers": "Corrieri",
		"no_couriers": "Nessun corriere disponibile",
		"couriers_not_loaded": "Scegli un indirizzo di consegna per vedere i corrieri disponibili",
		"couriers_no_cart": "Scegli i prodotti da ordinare per vedere i corrieri disponibili",
		"missing_order_data": "Inserisci nome e telefono per vedere i corrieri disponibili",
		"missing_sender_data": "Mancano indirizzo completo o alcuni dati di [0], non è possibile procedere con l'ordine",
		"customer_address_incomplete": "Manca il numero civico o il CAP nell'indirizzo fornito, correggilo per vedere i corrieri disponibili",
		"missing_courier": "Scegli un corriere per procedere con l'ordine",
		"free": "Gratis",
		"free_shipping_above": "Spedizione gratuita oltre [0]",
		"leave_review_after_order": "Puoi lasciare la tua recensione dopo aver effettuato un ordine",
		"last_one_to_order": "Sei l'ultimo ad ordinare?",
		"buffering_explain": "Prepareremo il tuo ordine appena gli altri avranno ordinato",
		"no_buffering_explain": "Inizieremo a preparare subito tutti gli ordini di questo tavolo",
		"products_unavailable": "Alcuni dei prodotti scelti non sono più disponibili",
		"product_unavailable_warehouse": "La quantità massima disponibile per il prodotto [0] è diventata [1]",
		"product_unavailable": "Non puoi più ordinare il prodotto [0]",
		"product_unavailable_other_cart": "Hai già [1] prodotti simili a [0] nel carrello, che è la quantità massima disponibile",
		"delivery_costs": "Costi di consegna",
		"takeaway_costs": "Costi asporto",
		"courier_costs": "Costi corriere",
		"payment_failed": "Pagamento non riuscito",
		"pay_x": "Paga [0]",
		"days": "[0] giorni",
		"day": "Un giorno",
		"same_day": "Oggi",
		"time_x": "Orario [0]",
		"order_data": "Dati dell'ordine",
		"name": "Nome",
		"email": "Email",
		"phone": "Telefono",
		"no_menus_available": "Nessun prodotto disponibile",
		"order_now": "Ordina ora",
		"order": "Ordina",
		"empty_cart": "Il carrello è vuoto",
		"bollo_tax": "Imposta di bollo",
		"do_you_have_coupon_code": "Hai un codice sconto?",
		"discount": "Sconto",
		"coupon_code": "Codice sconto",
		"coupon_invalid": "Codice sconto non valido",
		"coupon_duplicate": "Codice sconto già utilizzato",
		"coupon_min_order_value": "Codice sconto non valido per ordini inferiori a [0]",
		"coupon_cant_stack": "Non puoi utilizzare questi codici sconto insieme",
		"coupon_already_used": "Codice sconto già utilizzato",
		"coupon_mode": "Codice sconto non valido per questo tipo di ordine",
		"amount_left": "Importo rimanente",
		"no_linked_products": "Il codice sconto non si applica a nessun prodotto nel carrello",
		"reservation_error": "Non è stato possibile effettuare la prenotazione, riprova più tardi.",
		"availability_error": "Non è stata trovata disponibilità per la data e il numero di persone selezionati.",
		"waitlist_error": "Non è stato possibile aggiungerti alla lista d'attesa, riprova più tardi.",
		"waitlist_duplicate": "Sei già in lista d'attesa per questa data.",
		"waitlist_spot_available": "Buone notizie: si è liberato un posto! Scegli l'orario per prenotare.",
		"warning": "Attenzione",
		"use_cookies_title": "Utilizziamo i cookie necessari per il funzionamento della piattaforma.",
		"click_here_to_view": "Clicca qui per visualizzare",
		"the_cookie_policy": "la cookie policy",
		"cookie_info": "Per negare il consenso, clicca su No. Per consentire i nostri cookie, clicca su OK.",
		"privacy_policy": "Informativa Privacy",
		"email_required": "Email richiesta",
		"email_required_explain": "Inserisci la tua email per ricevere la conferma dell'ordine",
		"how_many_people": "Quanti siete?",
		"how_many_people_explain": "Inserisci il numero di persone per cui stai ordinando",
		"number_of_people": "Numero di persone",
		"people_pay_for": "Per quanti stai pagando?",
		"no_items": "Nessun prodotto",
		"max_items": "Non è possibile ordinare più di [0] prodotti alla volta. Se vuoi ordinare altri prodotti, completa prima l'ordine corrente.",
		"captcha_failed": "Non riusciamo a verificare l'affidabilità di questo dispositivo. Prova da un altro browser o dispositivo.",
		"payment_method_unaccepted": "[0] non accetta più questo metodo di pagamento.",
		"far_away_explain": "Non ti trovi vicino a [0]. Se stai utilizzando una VPN ti chiediamo di disattivarla.",
		"too_close_explain": "Il tuo indirizzo è troppo vicino a [0] per la consegna.",
		"courier_no_rate": "Seleziona un corriere per procedere con l'ordine.",
		"courier_payment_explain": "Per la spedizione con corriere è necessario pagare con carta, Apple pay o Google pay.",
		"payment_method_issue": "Si è verificato un problema, prova con un altro metodo di pagamento.",
		"delivery_not_accepted": "[0] non accetta ordini con consegna in questo momento.",
		"takeaway_not_accepted": "[0] non accetta ordini da ritirare in questo momento.",
		"stock_invalid": "Uno o più prodotti nel tuo carrello superano la quantità disponibile.",
		"orders_queue_many": "ordini davanti a te",
		"orders_queue_one": "Un ordine davanti a te",
		"orders_queue_empty": "Nessun ordine in coda",
		"cover_charge_invalid": "[0] non è stato calcolato correttamente, riprova per favore.",
		"takeaway_time_invalid": "Scegli un orario di ritiro valido per l'asporto.",
		"missing_order_date": "Scegli la data dell'ordine",
		"missing_order_time": "Scegli l'orario dell'ordine",
		"missing_custom_answer": "Rispondi alla domanda per procedere con la prenotazione",
		"loading_stripe": "Sistema di pagamento non disponibile, riprova tra qualche secondo.",
		"saved_cards": "Carte salvate",
		"add_card": "Aggiungi carta",
		"back_to_existing": "Torna alle carte salvate",
		"pay_with_card": "Paga con carta",
		"with_card": "Con carta",
		"long_ago": "QR scaduto",
		"long_ago_assistance_explain": "Scannerizza di nuovo il QR CODE per chiamare assistenza. I prodotti che hai scelto resteranno selezionati.",
		"long_ago_explain": "Scannerizza di nuovo il QR CODE per procedere con l'ordine. I prodotti che hai scelto resteranno selezionati.",
		"long_ago_pay_bill_explain": "Scannerizza di nuovo il QR CODE per procedere con il pagamento.",
		"amount_changed": "Importo cambiato",
		"min_order": "Minimo ordine [0]",
		"new_amount": "Nuovo importo",
		"no_orders_now": "[0] non accetta ordini in questo momento, riprova più tardi.",
		"invalid_amount_type": "L'importo del pagamento è cambiato, riprova.",
		"choose_products_explain": "Scegli i prodotti cliccandoci sopra",
		"press_button_cart": "Premi il pulsante carrello che compare in basso a destra",
		"proceed_to_payment": "Procedi al pagamento e goditi il tuo ordine!",
		"total_amount": "Importo totale",
		"choose_amount": "Scegli l'importo",
		"choose_amount_explain": "Puoi pagare l'importo totale rimanente o solo una parte.",
		"total_bill": "Totale conto",
		"left_to_pay": "Resta da pagare",
		"address": "Indirizzo",
		"additional_notes": "Note aggiuntive",
		"product_notes": "Note prodotto",
		"products_x": "[0] prodotti",
		"product_single": "Un prodotto",
		"back_to_menu": "Torna al menù",
		"back_to_catalog": "Torna al catalogo",
		"menu_banner": "Banner menù",
		"cookie_policy": "Cookie policy",
		"terms_conditions": "Termini e Condizioni",
		"back": "Indietro",
		"search": "Cerca",
		"logo": "Logo",
		"order_summary": "Riepilogo ordine",
		"recaptchaV2Title": "Un piccolo passo per continuare",
		"additional_verification_code": "Codice di verifica aggiuntivo",
		"additional_verification_code_explain": "Per utilizzare il coupon [0] è necessario inserire un codice di verifica aggiuntivo.",
		"verification_code": "Codice di verifica",
		"insert_valid_verification_code": "Inserisci un codice di verifica valido",
		"invalid_verification_code_explain": "Il codice di verifica inserito non è valido. Riprova.",
		"kiosk_idle_warning_title": "Sei ancora qui?",
		"kiosk_idle_warning_body": "La sessione verrà chiusa tra:",
		"kiosk_idle_warning_cta": "Sono ancora qui",
		"consumer_login_track_orders": "Tieni traccia dei tuoi ordini",
		"consumer_go_to_profile": "Vai al profilo",
		"consumer_login_access_cta": "Accedi",
		"consumer_login_profile_cta": "Profilo"
	},
	"en": {
		"food": "Food",
		"special": "Special",
		"grains": "Grains",
		"nuts": "Tree Nuts",
		"dietary": "Dietary & More",
		"description": "Description",
		"long_description": "Long Description",
		"materials": "Materials",
		"ingredients": "Ingredients",
		"reviews": "Reviews",
		"reviews_x": "[0] reviews",
		"quality": "Quality",
		"service": "Service",
		"price": "Price",
		"location": "Location",
		"reservations": "Reservations",
		"menu": "Menu",
		"add": "Add",
		"add_x": "Add x[0]",
		"no_choice_available": "No choice available",
		"amount_to_pay": "Amount to pay",
		"how_do_you_want_to_pay": "How do you want to pay?",
		"pay_everything": "Pay everything",
		"pay_custom_amount": "Pay a partial amount",
		"split_evenly": "Split evenly",
		"pay_what_you_ordered": "Pay your share",
		"select_what_you_ordered": "Select your products",
		"clear": "Clear",
		"pay_the_bill": "Pay the bill",
		"mandatory": "Mandatory",
		"min_x": "Min. [0]",
		"max_x": "Max. [0]",
		"data_processing": "Data processing",
		"privacy_read_link": "I've read the [0]",
		"privacy_policy_link": "privacy policy",
		"allow_marketing": "and I give my consent for the analysis of my purchase choices and for promotional communications by email",
		"change_language": "Change Language",
		"allergens_filter_line_1": "Remove allergens to view only the products suitable for you.",
		"allergens_filter_line_2": "All products may contain traces of the following allergens.",
		"allergens_in_cart": "Products with allergens in cart",
		"allergens_in_cart_confirm": "There are products in the cart that contain allergens that you have chosen not to display. Do you want to keep them in the cart?",
		"product_filtered": "Product filtered",
		"product_filtered_confirm": "This product contains allergens that you have filtered. Do you want to add it to the cart anyway?",
		"category_filtered": "Category filtered",
		"category_filtered_confirm": "All the products in this category have allergens that you have filtered. Do you want to remove these filters?",
		"category_filtered_search_confirm": "All the products in this category do not match the search, do you want to remove the search?",
		"max_choice_list": "You can't add more than [0] products to the list [1]",
		"max_choice_list_single": "You can't add more than one product to the list [0]",
		"too_big_to_translate": "The menu is too big to be translated",
		"too_big_to_translate_catalog": "The catalog is too big to be translated",
		"conditions_not_matched_list": "Conditions not matched for list [0]",
		"conditions_not_matched_multiple_lists": "Conditions not matched for [0] lists",
		"not_available": "Not available",
		"item_not_available_quantity": "At this time you can't order more than [0] [1]",
		"category_not_available_quantity": "At this time you can't order more than [0] in the category [1]",
		"item_not_available": "You can't order the product [0]",
		"more_info_allergens_link": "For more information about allergens",
		"table_number": "Table number",
		"phone_number": "Phone number",
		"phone_number_explain": "You will receive a message when your order is ready.",
		"phone_country_code": "International prefix",
		"missing_phone_number": "Enter the phone number to be notified when the order is ready",
		"missing_table_number": "Enter the table number",
		"missing_customer_name": "Enter your name",
		"missing_customer_email": "Enter your email",
		"invalid_phone": "Invalid phone number",
		"invalid_email": "Invalid email",
		"invalid_captcha": "Invalid Capcha",
		"send_to_terminal": "Send to Kiosk",
		"or_pay_online": "Or pay online",
		"pay_in_3_installments": "Pay in 3",
		"generic_page_description": "Discover the [0] of [1] and all its products.",
		"pay_with": "Pay with",
		"satispay": "Satispay",
		"klarna": "Klarna",
		"cover_charge": "Cover charge",
		"expires": "Expires [0]/[1]",
		"order_time": "Order time",
		"ASAP": "ASAP",
		"no_date": "No date",
		"schedule": "Schedule",
		"missing_address": "Enter the delivery address by selecting it from the suggested ones",
		"address_details": "Delivery info (intercom, floor)",
		"popular": "Popular",
		"recommended": "Recommended",
		"popular_choices": "Popular choices",
		"we_recommend": "We recommend",
		"continue": "Continue",
		"pay_now": "Pay now",
		"pay_later": "Pay later",
		"cannot_be_zero": "The amount must be greater than zero",
		"cash": "Cash",
		"other_methods": "Other",
		"other_methods_full": "Other methods",
		"your_name": "Your name",
		"write_your_name": "Write your name",
		"click_here": "click here",
		"allergens_info": "Allergens info",
		"order_here": "Order here",
		"order_here_now": "Order here",
		"explain_coupon_button": "Click '+' to apply the coupon code",
		"notes": "Notes",
		"order_failed": "There was a problem. Please reload this page and try again.",
		"order_failed_later": "There was a problem. Please try again later.",
		"pay_card_declined": "Payment declined. Please try a different card.",
		"pay_network_error": "Connection error. Please try again in a moment.",
		"pay_requires_pin": "This card requires a PIN. Please use a different card or ask staff for help.",
		"fee_greater_than_total": "The fee is greater than the total, please try again.",
		"choose_time": "Choose time",
		"no_slots": "No slots available for this date",
		"couriers": "Couriers",
		"no_couriers": "No couriers available",
		"couriers_not_loaded": "Choose a delivery address to see the available couriers",
		"couriers_no_cart": "Choose the products to order to see the available couriers",
		"missing_order_data": "Enter name and phone to see the available couriers",
		"missing_sender_data": "Missing [0] full address or some data, it's not possible to proceed with the order",
		"customer_address_incomplete": "The provided address misses the street number or ZIP code, fix it to see the available couriers",
		"missing_courier": "Choose a courier to proceed with the order",
		"free_shipping_above": "Free shipping above [0]",
		"leave_review_after_order": "You can leave your review after placing an order",
		"last_one_to_order": "Are you last to order?",
		"buffering_explain": "We'll prepare your order once everyone else has ordered",
		"no_buffering_explain": "We will start preparing all the orders for this table immediately",
		"products_unavailable": "Some of the chosen products are no longer available",
		"product_unavailable_warehouse": "The maximum quantity available for the product [0] has become [1]",
		"product_unavailable": "You can't order the product [0] anymore",
		"product_unavailable_other_cart": "You already have [1] similar products to [0] in your cart, which is the maximum quantity available",
		"delivery_costs": "Delivery costs",
		"takeaway_costs": "Takeaway costs",
		"courier_costs": "Courier costs",
		"payment_failed": "Payment failed",
		"pay_x": "Pay [0]",
		"free": "Free",
		"days": "[0] days",
		"day": "One day",
		"same_day": "Today",
		"time_x": "Time [0]",
		"order_data": "Order data",
		"name": "Name",
		"email": "Email",
		"phone": "Phone",
		"no_menus_available": "No products available",
		"order_now": "Order now",
		"order": "Order",
		"empty_cart": "The cart is empty",
		"bollo_tax": "Bollo tax",
		"do_you_have_coupon_code": "Do you have a coupon code?",
		"discount": "Discount",
		"coupon_code": "Coupon code",
		"coupon_invalid": "Invalid coupon code",
		"coupon_duplicate": "Coupon code already used",
		"coupon_min_order_value": "Coupon code not valid for orders less than [0]",
		"coupon_cant_stack": "You can't use these coupon codes together",
		"coupon_already_used": "Coupon code already used",
		"coupon_mode": "Coupon code not valid for this type of order",
		"amount_left": "Amount left",
		"no_linked_products": "The coupon code does not apply to any product in the cart",
		"reservation_error": "It was not possible to make the reservation, please try again later.",
		"availability_error": "No availability found for the selected date and number of people.",
		"waitlist_error": "It was not possible to add you to the waiting list, please try again later.",
		"waitlist_duplicate": "You are already on the waiting list for this date.",
		"waitlist_spot_available": "Good news: a spot just freed up! Pick a time to book.",
		"warning": "Warning",
		"use_cookies_title": "We use the cookies necessary for the operation of the website.",
		"click_here_to_view": "Click here to view",
		"the_cookie_policy": "the cookie policy",
		"cookie_info": "To deny consent, click on No. To allow our cookies, click on OK.",
		"privacy_policy": "Privacy Policy",
		"email_required": "Email required",
		"email_required_explain": "Enter your email to receive the order confirmation",
		"how_many_people": "How many people?",
		"how_many_people_explain": "Enter the number of people you are ordering for",
		"number_of_people": "Number of people",
		"people_pay_for": "How many are you paying for?",
		"no_items": "No items",
		"max_items": "You can't order more than [0] products at a time. If you want to order other products, complete the current order first.",
		"captcha_failed": "We can't verify the reliability of this device. Try from another browser or device.",
		"payment_method_unaccepted": "[0] no longer accepts this payment method.",
		"far_away_explain": "You are not near [0]. If you are using a VPN, please to disable it.",
		"too_close_explain": "Your address is too close to [0] for delivery.",
		"courier_no_rate": "Select a courier to proceed with the order.",
		"courier_payment_explain": "For shipping with courier you need to pay with card, Apple pay or Google pay.",
		"payment_method_issue": "There was a problem, try with another payment method.",
		"delivery_not_accepted": "[0] does not accept delivery orders at this time.",
		"takeaway_not_accepted": "[0] does not accept takeaway orders at this time.",
		"stock_invalid": "One or more products in your cart exceed the available quantity.",
		"orders_queue_many": "orders ahead of you",
		"orders_queue_one": "One order ahead of you",
		"orders_queue_empty": "No orders in queue",
		"cover_charge_invalid": "[0] was not calculated correctly, please try again.",
		"takeaway_time_invalid": "Choose a valid pickup time for takeaway.",
		"missing_order_date": "Choose the order date",
		"missing_order_time": "Choose the order time",
		"missing_custom_answer": "Answer the question to proceed with the reservation",
		"loading_stripe": "Payment system not available, try again in a few seconds.",
		"saved_cards": "Saved cards",
		"add_card": "Add card",
		"back_to_existing": "Back to saved cards",
		"pay_with_card": "Pay with card",
		"with_card": "With card",
		"long_ago": "QR expired",
		"long_ago_assistance_explain": "Scan the QR CODE again to ask for assistance. The products you have chosen will remain selected.",
		"long_ago_explain": "Scan the QR CODE again to proceed with the order. The products you have chosen will remain selected.",
		"long_ago_pay_bill_explain": "Scan the QR CODE again to proceed with the payment.",
		"amount_changed": "Amount changed",
		"min_order": "Minimum order [0]",
		"new_amount": "New amount [0]",
		"no_orders_now": "[0] is not accepting orders at this time, please try again later.",
		"invalid_amount_type": "The payment amount changed, try again.",
		"choose_products_explain": "Choose the products by clicking on them",
		"press_button_cart": "Press the cart button that appears in the bottom right corner",
		"proceed_to_payment": "Proceed to payment and enjoy your order!",
		"total_amount": "Total amount",
		"choose_amount": "Choose amount",
		"choose_amount_explain": "You can pay the total remaining amount or a partial amount.",
		"total_bill": "Total bill",
		"left_to_pay": "Left to pay",
		"address": "Address",
		"additional_notes": "Additional notes",
		"product_notes": "Product notes",
		"products_x": "[0] products",
		"product_single": "One product",
		"back_to_menu": "Back to menu",
		"back_to_catalog": "Back to catalog",
		"menu_banner": "Menu banner",
		"cookie_policy": "Cookie policy",
		"terms_conditions": "Terms & Conditions",
		"back": "Back",
		"search": "Search",
		"logo": "Logo",
		"order_summary": "Order Summary",
		"recaptchaV2Title": "A small step to continue",
		"additional_verification_code": "Additional verification code",
		"additional_verification_code_explain": "To use coupon [0] you need to enter an additional verification code.",
		"verification_code": "Verification code",
		"insert_valid_verification_code": "Insert a valid verification code",
		"invalid_verification_code_explain": "Entered verification code is invalid. Please try again.",
		"kiosk_idle_warning_title": "Are you still here?",
		"kiosk_idle_warning_body": "The session will end in:",
		"kiosk_idle_warning_cta": "I'm still here",
		"consumer_login_track_orders": "Track your orders",
		"consumer_go_to_profile": "Go to profile",
		"consumer_login_access_cta": "Sign in",
		"consumer_login_profile_cta": "Profile"

	}
}